import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=eb81b9e2&lang=html"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"
import style0 from "./EventsView.vue?vue&type=style&index=0&id=eb81b9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports